export default function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_has.js
// module id = 49
// module chunks = 1